/* esm.sh - rxjs@7.8.2/dist/esm/internal/scheduler/dateTimestampProvider */
var e={now(){return(e.delegate||Date).now()},delegate:void 0};export{e as dateTimestampProvider};
//# sourceMappingURL=dateTimestampProvider.mjs.map